package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class AssociativeLife(
    val year: String,
    val organization: String,
    val role: String
)
